import httpClient from '@/http-client'

export const getServiceRequest = (Options = {}) => {
  return httpClient
    .get('/api/v1/service-managements/home/service-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getServiceRequest
}
